const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const usdFormatterNoDecimals = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

interface FormatCurrencyOptions {
  hideDecimals?: boolean;
}

export function formatCurrency(
  amount: number,
  { hideDecimals = false }: FormatCurrencyOptions = {},
): string {
  return hideDecimals
    ? usdFormatterNoDecimals.format(amount)
    : usdFormatter.format(amount);
}
